export enum ShortcutExitToType {
    CallingQuestion = 0,
    NextQuestion = 1,
}
